<template>
  <section class="product-specs">
    <p v-if="productRequired && !specs.title" class="placeholder">
      Kies een product bij dit bestand.
    </p>
    <div v-else class="specs">
      <spec class="spec title">{{ specs.title }}</spec>
      <template v-if="!compact && !productSpecs.userTemplate">
        <spec v-for="(value, name) in productSpecs" :key="name"
          ><span class="spec-title">{{ name }}:</span> {{ value }}</spec
        >
      </template>
      <template v-else-if="!compact && productSpecs.userTemplate">
        <spec v-for="(value, name) in productSpecs.specs" :key="name">
          {{ value }}</spec
        >
      </template>
    </div>
  </section>
</template>

<script>
import Spec from './Spec.vue'

export default {
  props: ['specs', 'productRequired', 'compact'],
  components: { Spec },
  computed: {
    productSpecs() {
      const myObj = { ...this.specs }
      delete myObj.title
      return myObj
    }
  }
}
</script>
<style lang="scss" scoped>
.spec.title {
  font-weight: 600;
}

.placeholder {
  padding-top: 6px;
}
</style>
